module.exports = __webpack_public_path__ + "static/about-us-01-500385c86915d4d3576fd704906c2b29.png";